import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import pointerIcon from '@/assets/images/icons/pointer.svg';
import editIcon from '@/assets/images/icons/edit.svg';

export default {
  name: 'AddressItem',
  components: {
    pointerIcon,
    editIcon,
  },
  props: {
    comp: null,
    disableServiceCenterPicker: false,
    selected: false,
  },
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      slotNumber: 'getSlotNumber',
    }),
  },
  methods: {
    ...mapMutations('appointment', {
      setAddressMution: 'SET_ADDRESS',
    }),
    ...mapActions('appointment', {
      clearSlotNumber: 'CLEAR_SLOTNUMBER',
    }),
    setServiceCenter() {
      this.setAddressMution(this.comp.id);
      if (this.slotNumber !== '' && this.selected === false) {
        this.clearSlotNumber(this.slotNumber);
      }

      this.$emit('on-set-service-center');
    },
  },
};
